/**
 * Canonical marketing auth URLs (must match app/config/routes.php and Craft general.php paths).
 */
export const AUTH_ROUTES = {
  LOGIN: '/login',
  SIGN_UP: '/sign-up',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_LINK: '/reset-link',
  SET_PASSWORD: '/login/set-password',
  PASSWORD_CHANGED: '/password-changed',
  ACCOUNT_ACTIVATE: '/account-activate',
} as const;

export const LOGIN_PATHS = [AUTH_ROUTES.LOGIN] as const;

export const SET_PASSWORD_PATHS = [AUTH_ROUTES.SET_PASSWORD] as const;

export function normalizeAuthPath(pathname: string): string {
  return pathname.replace(/\/+$/, '') || '/';
}

export function isLoginPath(pathname: string): boolean {
  const path = normalizeAuthPath(pathname);
  return (LOGIN_PATHS as readonly string[]).includes(path);
}

export const FORGOT_PASSWORD_PATHS = [AUTH_ROUTES.FORGOT_PASSWORD] as const;

export function isForgotPasswordPath(pathname: string): boolean {
  const path = normalizeAuthPath(pathname);
  return (FORGOT_PASSWORD_PATHS as readonly string[]).includes(path);
}

export function isResetLinkPath(pathname: string): boolean {
  return normalizeAuthPath(pathname) === AUTH_ROUTES.RESET_LINK;
}

export function isPasswordChangedPath(pathname: string): boolean {
  return normalizeAuthPath(pathname) === AUTH_ROUTES.PASSWORD_CHANGED;
}

export function isSetPasswordPath(pathname: string): boolean {
  return normalizeAuthPath(pathname) === AUTH_ROUTES.SET_PASSWORD;
}

export function buildLoginUrl(returnUrl?: string | null): string {
  if (!returnUrl) {
    return AUTH_ROUTES.LOGIN;
  }
  const url = new URL(AUTH_ROUTES.LOGIN, window.location.origin);
  url.searchParams.set('return', returnUrl);
  return url.pathname + url.search;
}

export function buildForgotPasswordUrl(returnUrl?: string | null): string {
  const url = new URL(AUTH_ROUTES.FORGOT_PASSWORD, window.location.origin);
  if (returnUrl) {
    url.searchParams.set('return', returnUrl);
  }
  return url.pathname + url.search;
}

export function buildSignUpUrl(): string {
  return AUTH_ROUTES.SIGN_UP;
}
